import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './TermsConditions.css';

const TermsConditions = () => {
  // Page top par scroll karne ke liye on load
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // Animation settings for repeat performance (Hamesha work karega)
  const reveal = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.6, ease: "easeOut" } 
    }
  };

  return (
    <div className="terms-container">
      <motion.div 
        className="terms-card"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Header Section */}
        <div className="terms-header">
          <motion.h1 variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            TERMS & CONDITIONS
          </motion.h1>
          <div className="brand-accent-line"></div>
          <motion.div variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
             <h2 className="brand-name-top">Chandrama Holidays</h2>
             <p className="brand-tagline">A travel you’ll remember for a lifetime.</p>
             <p className="intro-text">These Terms & Conditions govern all bookings made with Chandrama Holidays.</p>
          </motion.div>
        </div>

        <div className="terms-content">
          {/* Section 1 */}
          <motion.section className="t-section" variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            <h3>1. Booking & Payment Policy</h3>
            <ul>
              <li>A booking is confirmed only after receipt of the required advance payment.</li>
              <li>Full payment must be completed before tour commencement unless otherwise agreed in writing.</li>
              <li>Failure to complete payment may result in cancellation of the booking.</li>
              <li>Prices are subject to change based on availability, fuel costs, or supplier revisions until booking is confirmed.</li>
            </ul>
          </motion.section>

          {/* Section 2 */}
          <motion.section className="t-section" variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            <h3>2. Cancellation & Refund Policy</h3>
            <p>Cancellation charges depend on the time of cancellation and supplier policies.</p>
            <div className="cancellation-table-wrapper">
                <p className="sub-heading">Unless otherwise specified in writing:</p>
                <ul className="policy-list">
                    <li><strong>30+ days before departure:</strong> 10% of total tour cost</li>
                    <li><strong>15–29 days before departure:</strong> 25%</li>
                    <li><strong>7–14 days before departure:</strong> 50%</li>
                    <li><strong>Less than 7 days before departure:</strong> 100%</li>
                </ul>
            </div>
            <p>Non-refundable components such as flights, certain hotels, permits, and visas will be charged as per supplier rules.</p>
            <p><strong>No-show:</strong> On the day of departure will be treated as 100% cancellation.</p>
            <p>Any eligible refund amount will be processed within 7–14 working days.</p>
          </motion.section>

          {/* Section 3 & 4 */}
          <motion.section className="t-section" variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            <h3>3. Changes to Itinerary</h3>
            <p>Chandrama Holidays reserves the right to modify itineraries due to: Weather conditions, Road or operational issues, Government restrictions, or Unforeseen circumstances.</p>
            <p className="highlight-box">Any additional cost arising from such changes must be borne by the traveler.</p>
            
            <h3>4. Travel Documents & Identification</h3>
            <ul>
                <li>Travelers are responsible for carrying valid government-issued ID.</li>
                <li>For international travel, passports must be valid for at least six (6) months from the date of travel.</li>
                <li>Chandrama Holidays is not responsible for denied boarding due to incomplete documentation.</li>
            </ul>
          </motion.section>

          {/* Section 5 & 6 */}
          <motion.section className="t-section" variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            <h3>5. Conduct & Behavior</h3>
            <p>Travelers are expected to maintain respectful conduct toward fellow travelers, coordinators, hotel staff, drivers, and local residents.</p>
            <p>Misconduct, harassment, illegal activities, or disruptive behavior may result in removal from the tour without refund. Any additional expenses arising from such removal will be borne by the traveler.</p>

            <h3>6. Safety & Participation</h3>
            <p>Participation in activities including adventure or outdoor experiences is voluntary and at the traveler’s own risk. Chandrama Holidays is not liable for injuries, accidents, or losses occurring during such activities.</p>
          </motion.section>

          {/* Section 7, 8 & 9 */}
          <motion.section className="t-section" variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            <h3>7. Travel Insurance & Medical Expenses</h3>
            <p>We strongly recommend comprehensive travel insurance covering Medical emergencies, Accidents, Trip cancellations, and Loss of baggage. Medical or evacuation expenses are the responsibility of the traveler.</p>

            <h3>8. Personal Belongings</h3>
            <p>Travelers are solely responsible for safeguarding personal belongings. Chandrama Holidays is not liable for loss, theft, or damage to personal items.</p>

            <h3>9. Unforeseen Circumstances (Force Majeure)</h3>
            <p>We are not responsible for delays, cancellations, or changes caused by Natural disasters, Political instability, Government restrictions, Pandemics, or Strikes. No compensation shall be provided.</p>
          </motion.section>

          {/* Section 10, 11 & 12 */}
          <motion.section className="t-section" variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            <h3>10. Photos & Media Usage</h3>
            <p>Photos or videos taken during tours may be used for promotional purposes. Travelers who do not wish to appear must inform us in writing before the tour.</p>

            <h3>11. Limitation of Liability</h3>
            <p>We act as a tour organizer and are not directly responsible for the acts of hotels, airlines, or third-party vendors. Our liability is limited to the amount paid for the tour.</p>

            <h3>12. Website & Pricing Errors</h3>
            <p>Chandrama Holidays reserves the right to correct any pricing or system error on the website and inform the traveler before confirmation.</p>
          </motion.section>

          {/* Final Footer */}
          <motion.div className="terms-footer-card" variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: false }}>
            <p className="thank-you">Thank you for choosing Chandrama Holidays.</p>
            <p className="final-promise">We look forward to planning a journey you’ll remember for a lifetime.</p>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default TermsConditions;